import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

import {distinctUntilChanged} from 'rxjs/operators';

declare var ga: Function;

@Component({
  selector: 'awair-root',
  templateUrl: './app.component.html',
  styleUrls: ['app.component.scss']
})

export class AppComponent implements OnInit {

  constructor(private router: Router) {
    router.events.pipe(
      distinctUntilChanged((previous: any, current: any) => {
        if (current instanceof NavigationEnd) {
          return previous.url === current.url;
        }
        return true;
      })
    ).subscribe((event: any) => {
      (<any>window).Appcues && (<any>window).Appcues.page();
      ga('set', 'page', event.urlAfterRedirects);
      ga('send', 'pageview');
    });
  }

  ngOnInit() {
  }
}
